export interface SellerBuyerData {
  buyerCode?: number;
}

export type SellerBuyerMap = Record<string, number>;

export let sellerByBuyerCode: SellerBuyerMap = {};

export function updateSellerByBuyerCode(data: Record<string, SellerBuyerData>): void {
  const map: SellerBuyerMap = {};

  for (const [sellerCode, seller] of Object.entries(data)) {
    if (seller.buyerCode != null) {
      map[String(seller.buyerCode)] = Number(sellerCode);
    }
  }

  sellerByBuyerCode = map;
}
